import { isColumnVisibleByDefault } from '../../../../utils/partialPermissionUtils';
import renderTags from './renderTags';

const tagsCol = (
  gantt,
  t,
  fieldNoPermission,
  triggerSetter,
  cursorCustomStyle
) => {
  const columnDefinition = {
    name: 'tags',
    label: 'Tags',
    data_type: 'array/images',
    visible: true,
    hide: !isColumnVisibleByDefault('tags'),
    span: 2,
    offset: 0,
    align: 'center',
    mode: 'multiple',
    from_values: 'toSelectTags',
    el_to_extract_from: 'id',
    el_to_label_from: ['name'],
    img_from: 'image',
    width: 125,
    groupable: false,
    groupable_switch: ['A → Z', 'Z → A'],
    orderable: false,
    orderable_switch: ['A → Z', 'Z → A'],
    filterable: true,
    resize: true,
    template: (task) => {
      return renderTags({
        column: columnDefinition,
        gantt,
        t,
        onlyRead: fieldNoPermission,
        task,
        mainObject: {},
        customMainClassName: ''
      });
    }
  };
  return columnDefinition;
};

export default tagsCol;
